import React, { useEffect, useState } from "react";
import Styles from "./AgreementTemplate.module.css";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import documentUploadService from "../Services/documentUpload.service";
import { toast } from "react-toastify";
import { toastProperties } from "../../commons/Toast/Toaster";
import EditIcon from "@mui/icons-material/Edit";
import bankingService from "../Services/banking.service";
import { useSelector } from "react-redux";

function formatDate(val) {
  let date = new Date(val);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const day = date.getDate().toString().padStart(2, "0");
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

const AgreementTemplateModal = ({ open, handleClose }) => {
  const companyId = useSelector((state) => state?.sessionState?.userList)?.[0]
    ?.companyId;
  let currDate = new Date().toLocaleDateString("en-GB");
  const [companyName, setCompanyName] = useState("Insert Company Name");
  const [chiefEngg, setChiefEngg] = useState("Chief Engineer");
  const [powerPurchase, setPowerPurchase] = useState("Power Purchase");
  const [stateDiscom, setStateDiscom] = useState("State Discom");
  const [insAddress, setInsAddress] = useState("Insert Address");
  const [nameDes, setNameDes] = useState("Name/Designation");
  const [dept, setDept] = useState("Department");
  const [loaFormat, setLoaFormat] = useState("LOA Number Format");
  const [generatlTermsCond, setGeneralTermsCond] = useState(
    "As per the Framework Agreement/As per the Listing Document"
  );
  const [date, setDate] = useState(currDate);
  const [addPoint, setAddPoint] = useState("");
  const [endNameandDes, setEndNameandDes] = useState("Name and Designation");
  const [copyText, setCopyText] = useState("Inset Details");

  const [allDetails, setAllDetails] = useState({});
  const [logo, setLogo] = useState("");
  const [logoId, setLogoId] = useState("");

  const [fileData, setFileData] = useState("");

  const [remarks, setRemarks] = useState([]);

  const [editActive, setEditActive] = useState(false);
  const [editId, setEditId] = useState("");
  const [defLogo,setDefLogo] = useState("")

  const getIndData = async () => {
    let res = await bankingService.getIntentById(companyId);
    if (res.data?.code == 200) {
      setRemarks(res?.data?.data?.addMorePoints || []);
      setFileData(res?.data?.data?.logo);
      setCompanyName(res?.data?.data?.companyName);
      setChiefEngg(res?.data?.data?.fromChiefEngineer);
      setPowerPurchase(res?.data?.data?.fromPowerPurchase);
      setStateDiscom(res?.data?.data?.fromStateDiscom);
      setInsAddress(res?.data?.data?.fromAddress);
      setLoaFormat(res?.data?.data?.loaNumber);
      setDate(res?.data?.data?.enterDate);
      setEndNameandDes(res?.data?.data?.endTextNameAndDesignation);
      setCopyText(res?.data?.data?.copyTo);
      setDefLogo(res?.data?.data?.logoId);
    }
  };

  useEffect(() => {
    getIndData();
  }, []);

  const handleFileUpload = async (e) => {
    const fileList = e?.target?.files;
    const { name, value } = e.target;
    if (fileList.length > 0) {
      const file = fileList[0];
      let extension = file.name.split(".").pop();
      let fileSize = file.size / 1024 / 1024;
      let extList = ["png", "svg", "jpeg", "jpg"];
      if (extList.includes(extension)) {
        if (fileSize <= 1) {
          let formData = new FormData();
          formData.append("file", file);
          const config = {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };
          let data = (
            await documentUploadService.documentUpload("LOGO", formData, config)
          )?.data;
          if (data?.data?.id) {
            setLogoId(data?.data?.id);
            getIndData();
            setLogo(fileList?.[0]);
            toast.success("Uploaded Successfully", toastProperties);
          } else {
            toast.error("Failed to upload File", toastProperties);
          }
        } else {
          toast.error("File Size Cannot Exceed 1mb", toastProperties);
        }
      } else {
        toast.error("Only Image formats can be uploaded", toastProperties);
      }
    } else {
      toast.error("Please Upload Required image", toastProperties);
    }
  };

  const handleLogoImage = (value) => {
    return URL.createObjectURL(value);
  };

  const handleEditRem = (data, index) => {
    setEditId(index);
    setEditActive(true);
    setAddPoint(data);
    // let newAr = remarks.slice(0, index).concat(remarks.slice(index + 1));
    // setRemarks(newAr);
  };

  const handleDelRem = (index) => {
    let newAr = remarks.slice(0, index).concat(remarks.slice(index + 1));
    setRemarks(newAr);
    setAddPoint("");
  };

  const handleAddRemark = () => {
    if (editActive) {
      remarks[editId] = addPoint;
      setAddPoint("");
      setEditActive(false);
      return;
    }
    if (addPoint?.length === 0) {
      return;
    }
    setRemarks((prev) => [...prev, addPoint]);
    setAddPoint("");
    setEditActive(false);
  };

  const handleSubmitDocs = async () => {
    let payload = {
      logo: logoId || defLogo,
      companyId: companyId,
      companyName: companyName,
      fromChiefEngineer: chiefEngg,
      fromPowerPurchase: powerPurchase,
      fromStateDiscom: stateDiscom,
      fromAddress: insAddress,
      toNameAndDesignation: "",
      toDepartment: "",
      loaNumber: loaFormat,
      enterDate: formatDate(date),
      addMorePoints: remarks,
      endTextNameAndDesignation: endNameandDes,
      copyTo: copyText,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let res = await documentUploadService.templateIndentSubmit(payload, config);
    if (res?.data?.code == 200) {
      toast.success("Template Generated", toastProperties);
      handleClose();
    }
  };

  const handleDateFormat = (value) => {
    setDate(value);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={Styles.modalContainer}>
        <div className={Styles.modalHeading}>
          <div>Generate Intent </div>
          <div onClick={handleClose} style={{ cursor: "pointer" }}>
            <CloseIcon />
          </div>
        </div>
        <div className={Styles.generationSection}>
          <div className={Styles.inputAgrCon}>
            <div className={Styles.detailsHead}>Please enter all Details</div>
            <div className={Styles.InputContainer}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {fileData && !logo && (
                  <img
                    style={{
                      height: "50px",
                      width: "100px",
                      objectFit: "contain",
                    }}
                    src={`data:image/png;base64,${fileData}`}
                    alt=""
                  />
                )}
              </div>
              <div className={Styles.eachInputSec}>
                <div>Upload Logo:</div>
                <input
                  type="file"
                  src=""
                  alt=""
                  onChange={(e) => handleFileUpload(e)}
                />
                {logo && (
                  <div>
                    <img
                      src={handleLogoImage(logo)}
                      style={{
                        height: "100px",
                        width: "100px",
                        objectFit: "contain",
                      }}
                      alt=""
                    />
                  </div>
                )}
              </div>
              <div className={Styles.eachInputSec}>
                <div>Company Name:</div>
                <input
                  type="text"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </div>
              <div className={Styles.eachInputSec}>
                <div>From -: Chief Engineer:</div>
                <input
                  type="text"
                  value={chiefEngg}
                  onChange={(e) => setChiefEngg(e.target.value)}
                />
              </div>
              <div className={Styles.eachInputSec}>
                <div>From :- Power Purchase</div>
                <input
                  type="text"
                  value={powerPurchase}
                  onChange={(e) => setPowerPurchase(e.target.value)}
                />
              </div>
              <div className={Styles.eachInputSec}>
                <div>From :- State Discom</div>
                <input
                  type="text"
                  value={stateDiscom}
                  onChange={(e) => setStateDiscom(e.target.value)}
                />
              </div>
              <div className={Styles.eachInputSec}>
                <div>From :- Insert Address</div>
                <input
                  type="text"
                  value={insAddress}
                  onChange={(e) => setInsAddress(e.target.value)}
                />
              </div>
              <div className={Styles.eachInputSec}>
                <div>To :- Name/Designation</div>
                <input
                  type="text"
                  value={nameDes}
                  onChange={(e) => setNameDes(e.target.value)}
                />
              </div>
              <div className={Styles.eachInputSec}>
                <div>To :- Department</div>
                <input
                  type="text"
                  value={dept}
                  onChange={(e) => setDept(e.target.value)}
                />
              </div>
              <div className={Styles.eachInputSec}>
                <div>Insert LOA Number :- </div>
                <input
                  type="text"
                  value={loaFormat}
                  onChange={(e) => setLoaFormat(e.target.value)}
                />
              </div>
              <div className={Styles.eachInputSec}>
                <div>General Terms & Conditions :- </div>
                <input
                  type="text"
                  value={generatlTermsCond}
                  onChange={(e) => setGeneralTermsCond(e.target.value)}
                />
              </div>
              <div className={Styles.eachInputSec}>
                <div>Enter Date :- </div>
                <input
                  type="date"
                  value={date}
                  onChange={(e) => handleDateFormat(e.target.value)}
                />
              </div>
              <div className={Styles.eachInputSec}>
                <div>End Text :- Name and Designation</div>
                <input
                  type="text"
                  value={endNameandDes}
                  onChange={(e) => setEndNameandDes(e.target.value)}
                />
              </div>
              <div className={Styles.eachInputSec}>
                <div>Copy to :- </div>
                <input
                  type="text"
                  value={copyText}
                  onChange={(e) => setCopyText(e.target.value)}
                />
              </div>
              <div className={Styles.eachInputSec}>
                <div>Remark :- Add More points</div>
                <input
                  type="text"
                  placeholder="Add More Remarks"
                  value={addPoint}
                  onChange={(e) => setAddPoint(e.target.value)}
                />
              </div>
              <div className={Styles.buttonArea}>
                <div
                  className={Styles.addRemarkButton}
                  onClick={handleAddRemark}
                >
                  {editActive ? "Edit" : "Add"} Remark
                </div>
                {editActive && (
                  <div
                    className={Styles.cancelButton2}
                    onClick={() => {
                      setEditActive(false);
                      setAddPoint("");
                    }}
                  >
                    Cancel
                  </div>
                )}
              </div>
              <div className={Styles.remarkContainer}>
                {remarks?.map((ele, index) => (
                  <div className={Styles.eachRemarksCont}>
                    <div>{ele?.substring(0, 50)}...</div>
                    {!editActive && (
                      <div className={Styles.iconsContainer}>
                        <div onClick={() => handleEditRem(ele, index)}>
                          <EditIcon
                            style={{ color: "black", fontSize: "14px" }}
                          />
                        </div>
                        <div onClick={() => handleDelRem(index)}>
                          <CloseIcon
                            style={{ color: "red", fontSize: "14px" }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={Styles.agrDisplaySec}>
            <img
              style={{ height: "100px", width: "70%", objectFit: "contain" }}
              src={`data:image/png;base64,${fileData}`}
              alt=""
            />
            <div className={Styles.companyName}>{companyName}</div>
            <div className={Styles.fromToSection}>
              <div className={Styles.fromSection}>
                <div>From</div>
                <div>{chiefEngg}</div>
                <div>{powerPurchase}</div>
                <div>{stateDiscom}</div>
                <div>{insAddress}</div>
              </div>
              <div className={Styles.toSection}>
                <div>To</div>
                <div>
                  <b>Name/Designation-Blank</b>
                </div>
                <div>
                  <b>Department - Blank</b>
                </div>
                <div>
                  <b>{companyName}</b>
                </div>
                <div>
                  <b>Org Address - Auto</b>
                </div>
              </div>
            </div>
            <div className={Styles.loaDate}>
              <div className={Styles.loaDateDetaile}>
                <div>LOA No.:</div>
                <div>{loaFormat}</div>
              </div>
              <div className={Styles.loaDateDetaile1}>
                <div>Date:</div>
                <div>{date}</div>
              </div>
            </div>
            <div className={Styles.subjectSection}>
              <div>Subject:</div>
              <div>
                Power swap arrangement by <b>{companyName}</b> with M/s.
                <b>Counter party {companyName}</b> via GNA EPL CFP{" "}
                <b>Ref No - From Listing</b>. add listing.
              </div>
            </div>
            <div className={Styles.subjectSection}>
              <div>Ref:</div>
              <div>
                <ul>
                  <li>
                    GNA EPL e-Listing <b>Listing No. - Auto</b> from{" "}
                    <b>Listing Date - Auto</b>
                  </li>
                  <li>
                    Your offer dated <b>Connection Date</b> on GNA Energy OTC
                    Platform
                  </li>
                </ul>
              </div>
            </div>
            <div className={Styles.letterheading}>
              <div className={Styles.commonTextT1}>Sir/Ma’am,</div>
              <div className={Styles.commonTextT1}>
                With reference to the above, we are pleased to place Letter of
                Award (LoA) in favour of <b>Counter Org. Name</b>, as per below
                mentioned arrangement.
              </div>
              <div className={Styles.commonTextT2}>
                Supply of Power from <b>Counter Org. Name</b> to {companyName}
              </div>
            </div>
            <div className={Styles.tableCOntainer}>
              <table>
                <tr>
                  <th>Utility</th>
                  <th>Period</th>
                  <th>Duration (Hrs.)</th>
                  <th>Quantum (MW)</th>
                </tr>
                <tr>
                  <td>{companyName}</td>
                  <td>Period</td>
                  <td>Duration (Hrs.)</td>
                  <td>Quantum (MW)</td>
                </tr>
                <div>
                  <b>Drawal Details</b>
                </div>
              </table>
            </div>
            <div className={Styles.returnText}>
              Return of Power by {companyName} Name to <b>Counter Org. Name</b>
            </div>
            <div className={Styles.tableCOntainer}>
              <table border={1}>
                <tr>
                  <th>Utility</th>
                  <th>Period</th>
                  <th>Duration (Hrs.)</th>
                  <th>Quantum (MW)</th>
                  <th>Return Ratio in %</th>
                </tr>
                <tr>
                  <td>
                    <b>Counter Org. Name</b>
                  </td>
                  <td>Period</td>
                  <td>Duration (Hrs.)</td>
                  <td>Quantum (MW)</td>
                  <td>Return Ratio in %</td>
                </tr>
                <div>
                  <b>Injection Details</b>
                </div>
              </table>
            </div>
            <div className={Styles.commonDetailsCont}>
              <div>
                <div>Delivery Point:</div>
                <div>
                  <b>My Delivey Point - Auto</b>
                </div>
              </div>
              <div>
                <div>Settlement rate (Rs./kWh) :</div>
                <div>
                  <b>My Settlement Rate - Auto</b>
                </div>
              </div>
              <div>
                <div>General Terms & Conditions:</div>
                <div>{generatlTermsCond} - listing No.</div>
              </div>
            </div>
            <div className={Styles.remarkContainer2}>
              <div className={Styles.remarkText}>Remarks: </div>
              <div className={Styles.remarkDetails}>
                <ol>
                  {remarks?.map((ele) => (
                    <li>{ele}</li>
                  ))}
                </ol>
              </div>
            </div>
            <div className={Styles.reqTabText}>
              You are requested to acknowledge the receipt of this LOA & give
              your acceptance on it.
            </div>
            <div className={Styles.endTextArea}>
              <div>Yours Faithfully,</div>
              <div>{endNameandDes}</div>
              <div>{companyName}</div>
              <div>{stateDiscom}</div>
            </div>
            <div className={Styles.endCopyTextArea}>
              <div>Copy To:-</div>
              <div>{copyText}</div>
            </div>
          </div>
        </div>
        <div className={Styles.buttonSection}>
          <div
            onClick={handleClose}
            className={`${Styles.cancelButton} ${Styles.buttonCommon}`}
          >
            Cancel
          </div>
          <div
            className={`btn-login ${Styles.buttonCommon}`}
            onClick={handleSubmitDocs}
          >
            Submit
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AgreementTemplateModal;
